<template>
  <r-dialog ref="dialog"
            class="dialog"
            :persistent="persistent"
            v-on="$listeners" >
    <div class="default-dialog column bg-riseup-beige no-wrap">
      <close-dialog-button v-if="closeButton" class="close-button" @click="hide"/>
      <div class="content" :class="{ padded }">
        <slot />
      </div>
    </div>

  </r-dialog>
</template>

<script>
import RDialog from '@/components/base/RDialog';
import CloseDialogButton from '@/components/base/CloseDialogButton';

export default {
  name: 'DefaultDialog',
  components: { CloseDialogButton, RDialog },
  props: {
    closeButton: Boolean,
    persistent: Boolean,
    padded: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    show() {
      this.$refs.dialog.show();
    },
    hide() {
      this.$refs.dialog.hide();
    },
  },
};
</script>

<style lang="scss" scoped>

// On mobile devices address bar and footer always gets shown, so we need to slim this down
body.platform-ios .q-dialog__inner--minimized > .default-dialog,
body.platform-android:not(.native-mobile) .default-dialog {
  max-height: calc(100vh - 60px);
}

.default-dialog {
  position: relative;
  width: 360px;
  // Overrides the max-height calculated by Quasar to allow the dialog to overflow from the bottom
  max-height: 100vh;

  .close-button {
    position: absolute;
    top: 16px;
    right: 16px;
  }

  .content {
    &.padded {
      padding: 36px 25px;
    }
  }

}

</style>
